import { IsEnglish } from '../../../utils/language';

export function sortServiceProvider(data) {
    return data.sort(function (a, b) {
        const nameA = IsEnglish() ? a.descriptionE.toLowerCase() : a.descriptionF.toLowerCase()
        const nameB = IsEnglish() ? b.descriptionE.toLowerCase() : b.descriptionF.toLowerCase()
        if (nameA < nameB) //sort string ascending
            return -1
        if (nameA > nameB)
            return 1
        return 0 //default return value (no sorting)
    });
}